import React from 'react';

export function BrowserCode() {
  return (
    <svg
      width="65"
      height="65"
      viewBox="0 0 65 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.5"
        x="10.002"
        y="25.7305"
        width="45.3592"
        height="27.3398"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M56.6294 0.876995C56.621 0.876967 56.6126 0.876953 56.6042 0.876953H7.51686C7.50845 0.876953 7.50005 0.876967 7.49164 0.876995H56.6294ZM64.0605 18.2751H0.0605469V57.4206C0.0605469 61.5386 3.39885 64.8769 7.51685 64.8769H56.6042C60.7222 64.8769 64.0605 61.5387 64.0605 57.4206L64.0605 18.2751ZM27.5134 31.2106C26.4214 30.1186 24.651 30.1186 23.5591 31.2106L16.7241 38.0455L16.625 38.1498C15.6332 39.2475 15.6663 40.942 16.7241 41.9998L23.5591 48.8348L23.6634 48.9339C24.761 49.9257 26.4556 49.8926 27.5134 48.8348L27.6126 48.7305C28.6043 47.6328 28.5712 45.9383 27.5134 44.8805L22.655 40.0227L27.5134 35.1649L27.6126 35.0606C28.6043 33.9629 28.5712 32.2684 27.5134 31.2106ZM41.1834 31.2105C40.0914 30.1186 38.321 30.1186 37.2291 31.2105C36.1712 32.2683 36.1382 33.9629 37.1299 35.0605L37.2291 35.1648L42.0875 40.0226L37.2291 44.8804C36.1712 45.9382 36.1382 47.6328 37.1299 48.7304L37.2291 48.8347C38.2869 49.8926 39.9814 49.9256 41.0791 48.9339L41.1834 48.8347L48.0183 41.9998C49.0762 40.9419 49.1092 39.2474 48.1175 38.1498L48.0183 38.0455L41.1834 31.2105Z"
        fill="currentColor"
      />
      <path
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M64.0605 18.275H0.0605469V8.33326C0.0605469 4.21526 3.39885 0.876953 7.51685 0.876953H56.6042C60.7222 0.876953 64.0605 4.21525 64.0605 8.33326V18.275ZM8.75951 13.9255C10.8185 13.9255 12.4877 12.2564 12.4877 10.1974C12.4877 8.13836 10.8185 6.46921 8.75951 6.46921C6.70051 6.46921 5.03136 8.13836 5.03136 10.1974C5.03136 12.2564 6.70051 13.9255 8.75951 13.9255ZM22.4293 10.1974C22.4293 12.2564 20.7602 13.9255 18.7012 13.9255C16.6422 13.9255 14.973 12.2564 14.973 10.1974C14.973 8.13836 16.6422 6.46921 18.7012 6.46921C20.7602 6.46921 22.4293 8.13836 22.4293 10.1974ZM28.643 13.9255C30.702 13.9255 32.3712 12.2564 32.3712 10.1974C32.3712 8.13836 30.702 6.46921 28.643 6.46921C26.584 6.46921 24.9148 8.13836 24.9148 10.1974C24.9148 12.2564 26.584 13.9255 28.643 13.9255Z"
        fill="currentColor"
      />
    </svg>
  );
}
